import { gql, useQuery } from '@apollo/client';
import * as React from 'react';

import {
  BlogEdit_GetPost,
  BlogEdit_GetPostVariables,
} from './graphql-types/BlogEdit_GetPost';

import { BlogEditModal } from './components/BlogEditModal';

const GET_POST = gql`
  query BlogEdit_GetPost($input: SinglePostInputV2!) {
    postV2(input: $input) {
      result {
        _id
        ... on BlogV2 {
          _id
          ...BlogEditModal_PostV2Fragment
        }
      }
    }
  }
  ${BlogEditModal.blogFragment}
`;

export const BlogEdit: React.FC<{
  postId?: string;
  // tagIds?: string[];
  tags: { _id: string; name: string }[];
  group?: { _id: string };
  organization?: { _id: string };
  closeModal: () => void;
  showFixedGroupName: boolean;
}> = (props) => {
  const { loading, data } = useQuery<
    BlogEdit_GetPost,
    BlogEdit_GetPostVariables
  >(GET_POST, {
    variables: {
      input: {
        id: props.postId,
      },
    },
    skip: !props.postId,
  });

  if (loading) {
    return null;
  }

  const blogPost = data?.postV2.result;
  if (blogPost && blogPost.__typename !== 'BlogV2') {
    throw new Error('invalid blog post');
  }

  return (
    <BlogEditModal
      groupId={props.group?._id}
      organizationId={props.organization?._id}
      // tagIds={props.tagIds}
      tags={props.tags}
      blog={blogPost ?? undefined}
      postId={props.postId}
      editing={!!props.postId}
      closeModal={props.closeModal}
      originalImage={
        blogPost?.bannerImage?.imageProxy
          ? {
              imageProxy: blogPost.bannerImage.imageProxy,
              imageId: blogPost.bannerImage._id,
            }
          : undefined
      }
      alreadyPublished={blogPost?.published ?? false}
    />
  );
};
